module.exports = __webpack_public_path__ + "img/format_quote.8a788f92.svg";